import React from 'react';
import { IconButton, Tooltip } from '@mui/material';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';

import { useContextualHelp } from '../../context/ContextualHelpContext';

// Ícono "?" reutilizable para pegar al lado de un campo de formulario --
// abre ContextualHelpDrawer con el contenido de `{module}/{topic}.md`,
// haciendo scroll a la sección `anchor` (el slug del heading `## ...` de
// ese campo dentro del .md) si se pasa uno.
//
// Convención para la fase de cableado (todavía no ejecutada, ver plan):
//   - TextField/Select de MUI: como `endAdornment` de `InputAdornment`,
//     por ejemplo:
//       <TextField
//         ...
//         InputProps={{
//           endAdornment: (
//             <InputAdornment position="end">
//               <HelpIcon module="seguridad" topic="roles" anchor="nombre-del-rol" />
//             </InputAdornment>
//           )
//         }}
//       />
//   - Switch/Checkbox/Autocomplete (no soportan InputAdornment de forma
//     nativa): como elemento hermano dentro de un
//     `<Stack direction="row" alignItems="center" spacing={0.5}>`, al lado
//     del control y su label.
const HelpIcon = ({ module, topic, anchor, size = 'small', sx }) => {
  const { openHelp } = useContextualHelp();

  const handleClick = (event) => {
    event.stopPropagation();
    event.preventDefault();
    openHelp({ module, topic, anchor });
  };

  return (
    <Tooltip title="Ver ayuda">
      <IconButton
        type="button"
        onClick={handleClick}
        size={size}
        aria-label="Ver ayuda"
        sx={{ color: 'var(--wb-muted-80)', ...sx }}
      >
        <HelpOutlineIcon fontSize={size} />
      </IconButton>
    </Tooltip>
  );
};

export default HelpIcon;
